"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dataLoaderAbstractFactory = void 0;
// (C) 2021 GoodData Corporation
var util_1 = require("@gooddata/util");
var constants_1 = require("./constants");
exports.dataLoaderAbstractFactory = function (createLoader) {
    var loaders = new util_1.LRUCache({ maxSize: constants_1.LOADER_CACHE_SIZE });
    return {
        forWorkspace: function (workspace) {
            var loader = loaders.get(workspace);
            if (!loader) {
                loader = createLoader(workspace);
                loaders.set(workspace, loader);
            }
            return loader;
        },
        reset: function () {
            loaders.clear();
        },
    };
};
//# sourceMappingURL=DataLoaderAbstractFactory.js.map